var wrappers = document.querySelectorAll(".acf-collapse-wrapper");
wrappers.forEach(function (wrapper) {
	const wrapperTitle = wrapper.getAttribute("data-collapse-name");

	const backdropFigure = wrapper.querySelector(".acf-collapse-wrapper__image");

	var collapses = wrapper.querySelectorAll("details.acf-collapse");
	collapses.forEach(function (collapse) {
		// This makes the collapses act like accordions
		collapse.setAttribute("name", wrapperTitle);

		let collapseImageId = wrapperTitle + "-" + collapse.getAttribute("data-collapse-name");
		collapse.setAttribute("data-collapse-image-id", collapseImageId);

		let collapseImage = document.createElement("img");
		collapseImage.src = collapse.getAttribute("data-collapse-image-src");
		collapseImage.srcset = collapse.getAttribute("data-collapse-image-srcset");
		collapseImage.alt = collapse.getAttribute("data-collapse-image-alt");
		collapseImage.id = collapseImageId;

		collapseImage.setAttribute("loading", "lazy");
		collapseImage.classList.add("hidden");

		backdropFigure.appendChild(collapseImage);

		collapse.addEventListener("toggle", function (event) {
			if (event.newState === "open") {
				collapseImage.classList.remove("hidden");
			}
			if (event.newState === "closed") {
				collapseImage.classList.add("hidden");
			}
		});
	});
});
